// Componente Logo - Logo de PinoHome usando imagen PNG original
// Usa el archivo PNG original para mantener exactamente el mismo diseño

/**
 * Componente Logo
 * Logo de PinoHome usando la imagen PNG original
 * @param {Object} props - Propiedades del componente
 * @param {string} props.className - Clases CSS adicionales
 * @param {number} props.height - Altura del logo (default: 50)
 * @param {boolean} props.showSubtitle - Mostrar "AMOBLAMIENTOS" (siempre visible en el PNG)
 */
function Logo({ className = '', height = null }) {
  const sanitizeEnvValue = (value) => typeof value === 'string' ? value.trim().replace(/^['"]|['"]$/g, '').trim() : value
  const normalizeAssetPath = (value, fallback) => {
    const cleaned = sanitizeEnvValue(value)
    if (!cleaned) return fallback
    if (/^https?:\/\//i.test(cleaned)) return cleaned
    let path = cleaned.replace(/\\/g, '/')
    if (path.startsWith('/public/')) path = path.replace(/^\/public\//, '/')
    if (path.startsWith('public/')) path = path.replace(/^public\//, '')
    if (!path.startsWith('/')) path = `/${path}`
    return path
  }
  const logoPath = normalizeAssetPath(import.meta.env.VITE_SYSTEM_LOGO_PATH, '/pinohome/logo.png')
  const systemName = sanitizeEnvValue(import.meta.env.VITE_SYSTEM_NAME) || 'Sistema MultiRubro'
  
  const style = {
    width: 'auto',
    objectFit: 'contain',
    display: 'block',
    maxWidth: '100%'
  }

  if (height) {
    style.height = `${height}px`
  }
  
  return (
    <img
      src={logoPath}
      alt={`${systemName} Logo`}
      className={className}
      style={style}
    />
  )
}

export default Logo

